import { render } from "./CommunitySafetyNews.vue?vue&type=template&id=279a8442"
import script from "./CommunitySafetyNews.vue?vue&type=script&lang=js"
export * from "./CommunitySafetyNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__